import { PRODUCT_SUBCATEGORY, FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY } from "../../utils/constants";
import RenderInput from "../../utils/RandarInput";
import { allProductFieldDetails } from "./product-fields";
import { useState } from "react";

interface FormProps {
  formValues: Record<string, any>;
  setFormValues: (values: Record<string, any>) => void;
  errors: Record<string, string>;
  setErrors: (errors: Record<string, string>) => void;
}

interface AddProductInfoProps {
  allFields: Array<{
    id: string;
    [key: string]: any;
  }>;
  fields: string[];
  state?: {
    productId?: string;
  };
  category: any;
  subCategory: any;
  form: FormProps;
  setFocusedField: (field: string | null) => void;
}

interface ProductFieldDetail {
  id: string;
  type?: string;
  [key: string]: any;
}

interface SubCategoryItem {
  value: string;
  protocolKey?: string;
}

const AddProductInfo = ({ 
  allFields, 
  fields, 
  state, 
  category, 
  subCategory, 
  form, 
  setFocusedField 
}: AddProductInfoProps) => {
  const { formValues, setFormValues, errors, setErrors } = form;
    console.log(fields)
  const getProductFieldDetails = (category_id: string): ProductFieldDetail | undefined => {
    return allFields.find((field) => field.id === category_id);
  };

  return (
    <>
      {fields?.map((category_id) => {
        const item = getProductFieldDetails(category_id);
        if (!item) return null;
        
        let returnElement = true;
        if (formValues?.productSubcategory1) {
          const subCatList = PRODUCT_SUBCATEGORY[formValues?.productCategory];
          const selectedSubCatObject = subCatList?.find(
            (subitem: SubCategoryItem) => subitem.value === formValues?.productSubcategory1
          );
          
          if (selectedSubCatObject && selectedSubCatObject.protocolKey) {
            const hiddenFields = FIELD_NOT_ALLOWED_BASED_ON_PROTOCOL_KEY[selectedSubCatObject.protocolKey];
            if (hiddenFields) {
              const fielditemAvailableInHidden = hiddenFields.find(
                (hiddenItem: string) => hiddenItem === item?.id
              );
              if (fielditemAvailableInHidden) {
                returnElement = false;
              }
            }
          }
        }

        if (returnElement) {
          return (
            <RenderInput
              key={item.id}
              previewOnly={!!(state?.productId && item.id === "productCode")}
              item={{
                ...item,
                type: item.type ?? 'text',
                error: errors?.[item.id] ? true : false,
                helperText: errors?.[item.id] || "",
              }}
              state={formValues}
              stateHandler={setFormValues}
              setFocusedField={setFocusedField}
            />
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export default AddProductInfo;